import styled from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, space, breakpoint } = theme

export const TutorialList = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${space.xl};

  @media (min-width: ${breakpoint.md}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${breakpoint.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const CardImage = styled.div`
  width: 100%;
  overflow: hidden;
`

export const CardInfos = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: ${space.lg};
`

export const Illustrator = styled.div`
  width: ${space.xl};
  margin-right: ${space.md};
  & img {
    max-width: 100%;
  }
`

export const Card = styled.a`
  display: block;
  width: 100%;
  height: auto;
  border-radius: ${borders.radius.lg};
  overflow: hidden;
  transition: box-shadow 0.4s ease-in-out;
  background-color: transparent;

  &:hover,
  &:focus {
    text-decoration: none;
    background-color: ${color.grayscale.white};
    box-shadow: 0px 0px 50px #1021331a;
  }

  &:active {
    background-color: ${color.grayscale.lighter};
  }

  &:not(:last-of-type) {
    margin-right: ${space.xl};
  }
`
